<template>
  <router-view />
</template>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
    'Noto Color Emoji';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

/* 全局样式 - 毛玻璃效果 */
.el-dialog {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15) !important;
}

.el-message-box {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.el-button--primary {
  background: linear-gradient(135deg, #c9b8a3 0%, #a89985 100%);
  border: none;
  transition: all 0.3s;
}

.el-button--primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(160, 130, 109, 0.3);
}

/* 表格样式优化 */
.el-table {
  background: transparent !important;
}

.el-table th.el-table__cell {
  background: rgba(201, 184, 163, 0.15) !important;
  color: #5a4a3a;
  font-weight: 600;
}

.el-table tr {
  background: transparent !important;
}

.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background: rgba(0, 0, 0, 0.02) !important;
}

.el-table__body tr:hover > td {
  background: rgba(201, 184, 163, 0.08) !important;
}

/* 输入框样式优化 */
.el-input__wrapper {
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
}

.el-input__wrapper:hover {
  border-color: #c9b8a3;
}

.el-input__wrapper.is-focus {
  border-color: #c9b8a3;
  box-shadow: 0 0 0 3px rgba(201, 184, 163, 0.15);
}

/* 选择器样式优化 */
.el-select-dropdown {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
}

/* 分页器样式优化 */
.el-pagination {
  display: flex;
  align-items: center;
}

.el-pagination button:hover,
.el-pager li:hover {
  color: #a89985;
}

.el-pager li.is-active {
  background: linear-gradient(135deg, #c9b8a3 0%, #a89985 100%);
  color: white;
}
</style>
